import { render, staticRenderFns } from "./HistoricoAlvaras.vue?vue&type=template&id=9e1933c2&"
import script from "./HistoricoAlvaras.vue?vue&type=script&lang=js&"
export * from "./HistoricoAlvaras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports